import api from './api';

/**
 * Servicio para gestionar el calendario escolar
 */
export const calendarioService = {
  /**
   * Obtiene todas las semanas del calendario de un año
   * @param {number} anio - Año del calendario (ej: 2026)
   * @returns {Promise<Array>} Lista de semanas del calendario
   */
  getByYear: async (anio = 2026) => {
    try {
      const response = await api.get(`/calendario/${anio}`);
      return response.data || [];
    } catch (error) {
      console.error(`Error al obtener calendario del año ${anio}:`, error);
      throw error;
    }
  },

  /**
   * Obtiene una semana específica del calendario
   * @param {number} id - ID de la semana
   * @returns {Promise<Object>} Datos de la semana
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/calendario/semana/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener semana ${id}:`, error);
      throw error;
    }
  },

  /**
   * Obtiene semanas en un rango de fechas
   * @param {string} fechaInicio - Fecha de inicio (YYYY-MM-DD)
   * @param {string} fechaFin - Fecha de fin (YYYY-MM-DD)
   * @returns {Promise<Array>} Semanas en el rango
   */
  getByRange: async (fechaInicio, fechaFin) => {
    try {
      const response = await api.get('/calendario', {
        params: {
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin
        }
      });
      return response.data || [];
    } catch (error) {
      console.error('Error al obtener semanas por rango:', error);
      throw error;
    }
  },
};

export default calendarioService;
